import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b5d88fd6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b5d88fd6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5d88fd6')) {
      api.createRecord('b5d88fd6', component.options)
    } else {
      api.reload('b5d88fd6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b5d88fd6", function () {
      api.rerender('b5d88fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/coupon/bookCouponClass/index.vue"
export default component.exports